<template>
	<v-card elevation="1" rounded="lg" class="fill-height d-flex flex-column">
		<v-card-title class="d-flex align-center py-3 px-4">
			<v-icon color="primary" size="20" class="me-2">mdi-account-heart</v-icon>
			<span class="text-subtitle-2">{{ $t("dashboard.topConsultants.title") }}</span>
		</v-card-title>

		<v-divider />

		<v-card-text class="flex-grow-1 pa-0">
			<div v-if="consultants.length === 0" class="d-flex flex-column align-center justify-center pa-6" style="min-height: 140px">
				<v-icon size="40" color="grey-lighten-1" class="mb-2">mdi-account-heart</v-icon>
				<span class="text-body-2 text-medium-emphasis">{{ $t("dashboard.topConsultants.noData") }}</span>
			</div>

			<v-list v-else density="compact" class="py-0">
				<v-list-item
					v-for="(person, index) in consultants"
					:key="person.id"
					:to="`/people/${person.id}`"
					class="px-4"
				>
					<template #prepend>
						<span class="text-caption text-medium-emphasis me-3 font-weight-bold" style="min-width: 16px">
							{{ index + 1 }}
						</span>
						<v-avatar
							:color="getAvatarColor(person.firstName)"
							size="32"
							class="me-1"
						>
							<v-img v-if="person.photoUrl" :src="person.photoUrl" />
							<span v-else class="text-white text-caption font-weight-bold">
								{{ getInitials(person) }}
							</span>
						</v-avatar>
					</template>
					<v-list-item-title class="text-body-2">
						{{ person.firstName }} {{ person.lastName }}
						<span v-if="person.nickname" class="text-medium-emphasis">({{ person.nickname }})</span>
					</v-list-item-title>
					<template #append>
						<v-chip size="x-small" color="warning" variant="tonal">
							{{ person.ticketCount }}
						</v-chip>
					</template>
				</v-list-item>
			</v-list>
		</v-card-text>
	</v-card>
</template>

<script setup lang="ts">
import type { TopConsultant } from "@/services/dashboardService";
import { usePersonFormatting } from "@/composables/usePersonFormatting";

const { getPersonAvatarColor } = usePersonFormatting();

defineProps<{
	consultants: TopConsultant[];
}>();

function getInitials(person: TopConsultant) {
	return `${person.firstName.charAt(0)}${person.lastName.charAt(0)}`.toUpperCase();
}

function getAvatarColor(name: string) {
	return getPersonAvatarColor(name);
}
</script>
